import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const sectionVariants = cva('w-full', {
  variants: {
    tone: {
      white: 'bg-bg-white',
      off:   'bg-bg-off',
      dark:  'bg-bg-dark text-white',
      tint:  'bg-[linear-gradient(160deg,rgba(0,194,255,0.04)_0%,rgba(79,53,214,0.04)_50%,rgba(160,32,200,0.03)_100%)]',
    },
    spacing: {
      sm: 'py-16',
      md: 'py-24',
      lg: 'py-[75px] md:py-[150px]',
      xl: 'py-[180px]',
      '2xl': 'py-[200px]',
    },
  },
  defaultVariants: { tone: 'white', spacing: 'lg' },
})

export interface SectionProps
  extends React.HTMLAttributes<HTMLElement>,
    VariantProps<typeof sectionVariants> {
  as?: 'section' | 'div'
}

export const Section = React.forwardRef<HTMLElement, SectionProps>(
  ({ className, tone, spacing, as = 'section', ...props }, ref) => {
    const Comp = as as 'section'
    return (
      <Comp
        ref={ref as React.Ref<HTMLElement>}
        className={cn(sectionVariants({ tone, spacing }), className)}
        {...props}
      />
    )
  },
)
Section.displayName = 'Section'
